export default __webpack_public_path__ + "static/entra-e4f1e25825028387e67202f4b50352bb.svg";